module.exports = __webpack_public_path__ + "img/row-img4.79188b38.png";